module.exports = __webpack_public_path__ + "img/upload img.4866252a.svg";